import styled from 'styled-components';

export const StyledBroadsiderPromoOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: "BebasNeue";
  font-size: 1.25rem;
  color: white;
  line-height: 1;
  text-transform: uppercase;
  gap: 8px;
  padding: 0 16px;
  height: 100%;
  width: 100%;
  cursor: pointer;

  img {
    padding: 16px;
    width: 40%;
  }

  .promo-desc {
    width: 60%;
  }
  
  .promo-big-text {
    font-family: "BebasNeue";
    font-size: 3.5rem;
    font-weight: 700;
    color: white;
    width: 40%;
    color: ${({ theme }) => theme.selection};
    padding-top: 6px;
  }
`;
